import {Icon as PeacockIcon} from '@pepsico-ds/ui'

/** @typedef {import('@pepsico-ds/ui').IIconProps} IconProps */

/** Wrapper around Peacock DS Icon. @param {IconProps} props */
export const Icon = props => <PeacockIcon {...props} />
